<template>
  <transition name="fade" mode="out-in">
    <div v-if="showHotspotContent && data" class="hotspot-overlay-content">
      <transition name="fade" mode="out-in">
        <ButtonClose
          v-if="!galleryFullscreen"
          @click.native="onCloseClick"
        />
      </transition>
      <v-container fluid fill-height>
        <transition name="fade" mode="out-in">
          <div v-if="!currentProduct" class="content-gallery">
            <div
              ref="galleryWrapper"
              :style="{
                transform: $vuetify.breakpoint.smAndUp ? 'translateX(' + galleryX + 'px)' : null
              }"
              class="gallery-wrapper pt-16"
            >
              <div
                class="item mx-sm-6 mb-md-2 mb-6"
                v-for="(item, index) in content"
                :key="'item' + index"
                :ref="'item' + index"
              >
                <div class="item-content" :style="{transitionDelay: ((index + 1) * 0.1) + 's'}">
                  <img v-if="item.oneOfAKind" :src="IconUnicum" class="unicum">
                  <div @click="onProductClick(item, index)" class="content pa-0">
                    <div class="frame" v-if="item.hotspotGallery[0]">
                      <v-img
                        eager
                        v-if="item.hotspotGallery[0]"
                        :src="'/media/' + item.hotspotGallery[0].id"
                        transition="fade"
                        class="img"
                      />
                    </div>
                  </div>
                  <button
                    @click="onProductClick(item, index)"
                    type="button"
                  >
                    <IconPlus />
                  </button>
                </div>
              </div>
            </div>
            <div class="d-none d-sm-flex align-center justify-center mt-sm-8" >
              <button
                v-show="content.length > 1"
                @click="updateImage(-1)"
                type="button"
                class="arrow left"
              >
                <IconArrowLeft />
              </button>
              <transition name="fade" mode="out-in" appear>
                <div :key="currentImage" class="slide-index">
                  <span v-show="content.length">{{ currentImage + 1 }}/{{ content.length  }}</span>
                </div>
              </transition>
              <button
                v-show="content.length > 1"
                @click="updateImage(1)"
                type="button"
                class="arrow right"
              >
                <IconArrowRight />
              </button>
            </div>
          </div>
        </transition>
        <transition name="fade" mode="out-in">
          <v-row v-if="currentProduct && !showContact" justify="center" align="center" class="fill-height ma-0">
            <v-col
              cols="12"
              md="7"
              align="center"
              class="pt-16 mt-6 mt-md-0 pt-sm-3 pr-md-16"
            >
              <Gallery
                :collection="currentProduct.hotspotGallery"
                :content360="(currentProduct.hotspotGallery360 || null)"
                :isPremium="currentProduct.oneOfAKind"
              />
            </v-col>
            <v-col
              v-if="captionExist && !galleryFullscreen"
              cols="12"
              md="3"
              class="pb-16 pb-sm-3"
            >
              <div class="description pr-6" :class="{'text-only': isTextOnly}">
                <ButtonBack @click.native="onBackClick" />
                <p class="mb-6" v-show="data.productRef.length > 1">
                  {{ currentImage + 1 }}/{{ data.productRef.length  }}
                </p>
                <MarkdownBlock
                  v-if="currentProduct[$route.params.language+'Description']"
                  :text="currentProduct[$route.params.language+'Description']"
                  :inline="true"
                  linkify
                  tag="p"
                  class="mb-6"
                />
                <MarkdownBlock
                  v-if="currentProduct[$route.params.language+'Caption']"
                  :text="currentProduct[$route.params.language+'Caption']"
                  :inline="true"
                  linkify
                  tag="p"
                  class="mb-6"
                />
                <button
                  @click="onClickCTA"
                  class="cta-contact"
                >
                  {{ $root.allLanguages[$language.current].ctaGetInfo }}
                </button>
              </div>
            </v-col>
          </v-row>
        </transition>
        <transition name="fade" mode="out-in">
          <v-row v-if="currentProduct && showContact" align="center" class="fill-height">
            <v-col cols="12">
              <ContactForm @on-back="onBackClick" :product="currentProduct" />
            </v-col>
          </v-row>
        </transition>
      </v-container>
    </div>
  </transition>
</template>

<script>
import { MarkdownBlock, Viewport } from '@monogrid/vue-lib'
import GetHotspotMultiProduct from '@/graphql/GetHotspotMultiProduct.gql'
import ButtonBack from '@/atoms/ButtonBack.vue'
import ButtonClose from '@/atoms/ButtonClose.vue'
import Gallery from '@/atoms/Gallery.vue'
import ContactForm from '@/molecules/ContactForm.vue'

import IconArrowLeft from '@/assets/svg/icon-previous.svg'
import IconArrowRight from '@/assets/svg/icon-next.svg'
import IconPlus from '@/assets/svg/plus-icon.svg'
import IconUnicum from '@/assets/img/unicum-icon-overlay.png'

export default {
  name: 'HotspotMultiProduct',
  mixins: [Viewport],

  data () {
    return {
      IconUnicum,
      showContact: false,
      data: null,
      GetHotspotMultiProduct,
      showHotspotContent: false,
      galleryX: 0,
      currentImage: 0,
      currentProduct: null,
      currentDescription: '',
      content: [],
      galleryFullscreen: false
    }
  },

  components: {
    IconArrowRight, IconArrowLeft, IconPlus, ButtonBack, ButtonClose, MarkdownBlock, ContactForm, Gallery
  },

  mounted () {
    this.$events.on('onGalleryFullscreen', (fullscreen) => {
      this.galleryFullscreen = fullscreen
    })
  },

  computed: {
    imagesGalleryExist () {
      return (this.currentProduct.hotspotGallery && this.currentProduct.hotspotGallery.length > 0)
    },

    captionExist () {
      return (this.currentProduct[this.$route.params.language + 'Description'] ||
        this.currentProduct[this.$route.params.language + 'Caption'])
    },

    isTextOnly () {
      return !this.imagesGalleryExist
    }
  },

  methods: {
    onProductClick (item, index) {
      this.currentImage = index
      this.currentProduct = item
      if (window.dataLayer && this.currentProduct && this.currentProduct.SKU) {
        window.dataLayer.push({
          event: 'generic_event',
          eventCategory: this.$route.params.roomName.split('-')[1] + ' - SKU' + (this.currentProduct.oneOfAKind ? ' - UNICUM' : ''),
          eventLabel: 'Open Product Detail',
          eventAction: this.currentProduct.SKU
        })
      }
    },

    async loadData () {
      this.$events.emit('onHideLogo')
      this.galleryX = 0
      this.currentImage = 0
      this.content = []
      for (let i = 0; i < this.HotspotMultiProduct.productRef.length; i++) {
        const element = this.HotspotMultiProduct.productRef[i]

        if (element.hotspotGallery.length) {
          this.content.push(element)
        }
      }
      await this.$nextTick()

      this.updateResize()
    },
    updateImage (index) {
      this.$refs.galleryWrapper.style.transition = 'transform 0.4s ease-in-out'

      const gallery = this.$refs.galleryWrapper

      if (gallery) {
        this.currentImage += index

        if (this.currentImage < 0) {
          this.currentImage = 0
        }

        if (this.currentImage > this.content.length - 1) {
          this.currentImage = this.content.length - 1
        }

        this.updateResize()
      }
    },
    updateResize () {
      let tx = 0
      for (let i = 0; i < this.currentImage; i++) {
        const el = this.$refs['item' + i][0]
        // console.log(el)
        if (el) {
          tx -= (el.clientWidth + 48)
        }
      }

      tx += (this.viewPort.width / 2)
      const curel = this.$refs['item' + this.currentImage]
      if (curel) {
        tx -= (curel[0].clientWidth + 48) / 2
        this.galleryX = tx

        this.currentDescription = this.content[this.currentImage][this.$route.params.language + 'Description'] ? this.content[this.currentImage][this.$route.params.language + 'Description'] : ''
      }
    },

    onClickCTA () {
      this.showContact = true
      this.$events.emit('onShowLogo')
      if (window.dataLayer && this.currentProduct && this.currentProduct.SKU) {
        window.dataLayer.push({
          event: 'generic_event',
          eventCategory: this.$route.params.roomName.split('-')[1] + ' - SKU' + (this.currentProduct.oneOfAKind ? ' - UNICUM' : ''),
          eventLabel: 'Click on CTA',
          eventAction: this.currentProduct.SKU
        })
      }
    },

    onBackClick () {
      if (this.data.productRef.length === 1) {
        this.onCloseClick()
        return
      }
      if (this.showContact) {
        this.showContact = false
        this.$events.emit('onHideLogo')
      } else {
        this.currentProduct = null
      }
    },

    onCloseClick () {
      this.$events.emit('onShowLogo')
      this.showContact = false
      this.currentProduct = null
      this.galleryFullscreen = false
      this.$router.push({ params: { hotspotContent: null } })
    },

    checkRoute (routeValue) {
      // console.log('Open hotspot', this.$route.params.hotspotContent)
      if (this.$route.params.hotspotContent || (routeValue && routeValue.params.hotspotContent)) {
        // this.showHotspotContent = true
        // this.$events.emit('onHotspotOpen')
      } else {
        this.showHotspotContent = false
        this.$events.emit('onHotspotClose')
      }
    }
  },

  apollo: {
    HotspotMultiProduct: {
      query: GetHotspotMultiProduct,
      skip () {
        return !this.$route.params.hotspotContent
      },
      variables () {
        return {
          slug: this.$route.params.hotspotContent
        }
      },
      async result (resultData, { key }) {
        // console.log('result', resultData)
        // console.log('Get Room result:', this.Room)
        if (this.HotspotMultiProduct && resultData.data) {
          this.showHotspotContent = true
          this.$events.emit('onHotspotOpen')
          this.data = this.HotspotMultiProduct
          if (this.data.productRef.length === 1) {
            this.currentProduct = this.data.productRef[0]
          } else {
            this.loadData()
          }
        } else {
          this.data = null
        }
      }
    }
  },

  watch: {
    '$route' (newValue, oldValue) {
      this.checkRoute(newValue)
    },

    viewPort () {
      if (!this.currentProduct) this.updateResize()
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s !important;
}

.fade-enter,
.fade-leave-to {
  opacity: 0 !important;
}

.hotspot-overlay-content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $c-pink;
  z-index: 20;

  @include breakpoint('xs-only') {
    overflow-y: scroll;
  }
}

h4 {
  font-size: 32px;
}

.cta-contact {
  outline: none;
  background-color: $c-white;
  padding: 6px 24px;
  border-radius: 100px;
  transition: all 0.25s $ease-in-out-quad;

  &:hover {
    background: $c-black;
    color: $c-white;
  }
}

.content-gallery {
  position: fixed;
  width: 100%;
  left: 0;
  top: 50%;
  height: fit-content;
  transform: translate(0, -50%);
  overflow: visible;

  @include breakpoint('xs-only') {
    position: relative;
    width: 100%;
    transform: none;
    top: auto;
    margin-top: 20px;
    margin-bottom: 20px;
  }
}

.gallery-wrapper {
  display: inline-flex;

  @include breakpoint('xs-only') {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
  }
}

.item-content {
  height: fit-content;
  text-align: center;
  position: relative;
  height: 100%;

  .frame {
    padding: 0;
    // background-color: $c-white;
    // margin: 5px;
    position: relative;
    overflow: visible;
    @include breakpoint('xs-only') {
      padding: 7px;
    }
  }

  .content {
    z-index: 1;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: fit-content;
    width: fit-content;
    // border: 1px solid $c-white;
  }

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -25px;
    z-index: 1000;
    background-color: $c-pink;
    border: 1px solid $c-white;
    width: 50px;
    height: 50px;
    border-radius: 50%;

    @include breakpoint ('xs-only') {
      bottom: -18px;
    }

    &:hover {
      transform: translateX(-50%) rotate(180deg);
    }

    svg {
      stroke: $c-black;
      width: 20px;
      height: 20px;
    }
  }
}

.img {
  height: 30vw;
  width: 30vw;
  max-width: calc(65vh - 48px);
  max-height: calc(65vh - 48px);
  background-size: contain;
  background-position: center center;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  @include breakpoint ('sm-only') {
    height: 50vw;
    width: 50vw;
  }

  @include breakpoint('xs-only') {
    width: 80vw;
    height: 80vw;
  }

  ::v-deep .v-image__image {
    transition: transform 0.4s $ease-in-out-quad;
  }

  &:hover ::v-deep .v-image__image {
    transform: scale(1.05);
  }
}

.unicum {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  transform: translate(50%, -50%);
  width: 100px;
  height: 100px;
  transition: transform 0.4s $ease-in-out-quad;

  @include breakpoint ('sm-only') {
    width: 85px;
    height: 85px;
    transform: translate(50%, -50%);
  }

  @include breakpoint ('xs-only') {
    width: 70px;
    height: 70px;
    transform: translate(30%, -30%);
  }
}

.slide-index {
  width: 250px;
  text-align: center;
}

button {
  outline: none;
  transition: transform 0.4s $ease-in-out-quad;

  &.left:hover svg path {
    @include breakpoint ('md-and-up') {
      animation: onHoverLeft 0.4s ease-in-out;
    }
  }

  &.right:hover svg path {
    @include breakpoint ('md-and-up') {
      animation: onHoverRight 0.4s ease-in-out;
    }
  }

  &.arrow {
    width: 48px;
    height: 48px;

    svg {
      width: 100%;
      height: 100%;
    }
  }

}

@keyframes onHoverLeft {
  0% {
    transform: translate3d(0%, 0%, 0);
    opacity: 1;
  }

  33% {
    transform: translate3d(-50%, 0%, 0);
    opacity: 0;
  }

  34% {
    transform: translate3d(50%, 0, 0);
    opacity: 0;
  }

  100% {
    transform: translate3d(0%, 0%, 0);
    opacity: 1;
  }
}

@keyframes onHoverRight {
  0% {
    transform: translate3d(0%, 0%, 0);
    opacity: 1;
  }

  33% {
    transform: translate3d(50%, 0%, 0);
    opacity: 0;
  }

  34% {
    transform: translate3d(-50%, 0, 0);
    opacity: 0;
  }

  100% {
    transform: translate3d(0%, 0%, 0);
    opacity: 1;
  }
}

</style>
